import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../../mock';

function Stars({ rating }) {
  return (
    <div className="flex items-center gap-0.5 text-amber-400">
      {Array.from({ length: 5 }).map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill={i < Math.floor(rating) ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [page, setPage] = useState(0);
  const perPage = 3;
  const pages = Math.ceil(testimonials.length / perPage);
  const visible = testimonials.slice(page * perPage, page * perPage + perPage);

  return (
    <section id="reviews" className="py-16 md:py-4 bg-gradient-to-br from-pink-50/40 via-white to-pink-50/40">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="zp-section-title">
              What Our <span className="zp-gradient-text">Customers</span> Say
            </h2>
            <p className="mt-4 text-slate-600">
              From busy professionals to everyday fashion lovers — they love us! Read real stories from customers who experience fashion-care on demand.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setPage(p => Math.max(0, p - 1))}
              className="h-11 w-11 grid place-items-center rounded-full border border-pink-200 text-[#E91E80] hover:bg-[#E91E80] hover:text-white transition-colors"
              disabled={page === 0}
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={() => setPage(p => Math.min(pages - 1, p + 1))}
              className="h-11 w-11 grid place-items-center rounded-full border border-pink-200 text-[#E91E80] hover:bg-[#E91E80] hover:text-white transition-colors"
              disabled={page >= pages - 1}
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {visible.map((t, idx) => (
            <div key={idx} className="zp-card p-7 flex flex-col">
              <div className="flex items-center gap-3">
                <div className="h-12 w-12 rounded-full bg-gradient-to-br from-[#FF3E9E] to-[#E91E80] text-white grid place-items-center font-bold text-lg flex-shrink-0">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-slate-900">{t.name}</div>
                  <Stars rating={t.rating} />
                </div>
              </div>
              <p className="mt-4 text-slate-600 text-sm leading-relaxed flex-1">"{t.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
